export default {"src":"/_next/static/media/ai-powered-optimization.5f2ad299.svg","height":41,"width":41,"blurWidth":0,"blurHeight":0};